<template>
    <div id="userChgCard">
        <em><span>尊敬的客户，您的换卡申请预计在2-5个工作日内处理完毕，请耐心等待。</span></em>






        <van-cell-group class="form-input">
            <van-field v-model="recordLoginText" required label="ICCID：" readonly />

            <van-field v-model="userInfo.takeNickname" required clearable label="收件人姓名：" placeholder="请输入您的姓名"
                :disabled="disabledFlag" />

            <van-field v-model="userInfo.takePhone" required clearable label="手机号码：" placeholder="请输入您的手机号码"
                :disabled="disabledFlag" />

            <van-field v-model="userInfo.pcaAddress" required clearable label="地区：" placeholder="请选择地区" readonly
                @click="showAddressVisible()" />

            <van-field v-model="userInfo.takeAddress" required clearable label="详细地址：" placeholder="请输入您的详细地址"
                :disabled="disabledFlag" />

            <!-- <van-field
                v-model="userInfo.changeCmccSimName"
                required
                clearable
                label="卡类型："
                placeholder="请选择卡类型"
                readonly
                @click="showPopupVisible()"
            /> -->

            <!-- <p class="tip" v-if="userInfo.disposeState != 2">{{tips}}</p> -->

            <van-field v-model="userInfo.equipment" required clearable :disabled="disabledFlag" label="换卡备注："
                placeholder="请输入您的备注" />

            <van-field v-if="userInfo.disposeState == 2 || userInfo.disposeState == 3" v-model="userInfo.disposeRemark"
                readonly :disabled="disabledFlag" :label="userInfo.disposeState == 2 ? '处理结果：' : '快递单号：'" />

        </van-cell-group>




        <!--  地区选择  -->
        <van-popup v-model="addressVisible" position="bottom">
            <van-area :area-list="areaList" :columns-placeholder="['请选择', '请选择', '请选择']" @cancel="cancelSelectAddress()"
                @confirm="selectAddress" />
        </van-popup>

        <!-- 卡类型选择 -->
        <van-popup v-model="popupVisible" position="bottom">
            <van-picker show-toolbar :columns="slots" :default-index="defaultIndex"
                @cancel="popupVisible = !popupVisible" @confirm="selectValue" />
        </van-popup>


        <div class="btnOuter">
            <!-- <p class="tip" v-if="isNeedPostage" >亲，我司提供免费换卡，但为避免资源浪费，预收5元邮费，待新卡完成首笔充值后便可以在充值页面公告栏处申请邮费全额原路返还哦。</p><br> -->
            <mt-button v-if="isNeedPostage" type="primary" size="large" @click="payPostage()">支付邮费</mt-button>
            <mt-button v-if="disabledFlag == false && isNeedPostage == false" type="primary" size="large"
                @click="applyChgCardHandler()">申请换卡</mt-button>

            <!-- <mt-button style="margin-top: 5px;" v-if="!isNeedPostage" type="primary" size="large" @click="toBackPostagePage()">申请退还邮费</mt-button> -->
        </div>
    </div>
</template>
<script>
import { Dialog } from 'vant';
import { Toast } from 'vant';

import { wxRequest } from '@/api/user.js'
import myaddress from '@/utils/pca.json'
import areaListData from '@/utils/Area.js'

export default {
    name: 'userChgCard',
    data() {
        return {
            recordLoginText: localStorage.getItem('recordLoginText'),
            leshuaPay: localStorage.getItem('leshuaPay'),
            userInfo: {
                oldIccid: '',
                takeNickname: '',
                takePhone: '',
                pcaAddress: '',
                takeAddress: '',
                disposeState: '',
                disposeRemark: '',
                changeCmccSim: 6,
                changeCmccSimName: '任意卡',
                equipment: '',
            },
            detailAddress: '',
            disabledFlag: false,
            slots: ['联通卡', '移动卡', '任意卡'],
            defaultIndex: 0,

            //卡类型
            popupVisible: false,

            addressVisible: false,
            areaList: areaListData,
            addressTmp: '',

            //是否需要支付邮费
            isNeedPostage: false,

            tips: '温馨提醒：新卡套餐流量为全国流量 和旧卡规格相同。'

        }
    },
    methods: {
        applyChgCardHandler() {
            if (this.userInfo.takeNickname == '' || this.userInfo.takePhone == '' || this.userInfo.takeAddress == '' || this.userInfo.pcaAddress == '') {
                Dialog.alert({ title: '提示', message: '请确保信息完整正确' });
                return;
            }
        
            var data = JSON.parse(JSON.stringify(this.userInfo));
            wxRequest("applyChangeSim/add", data, "post").then(res => {
                if (res.data.code == 200) {
                    Dialog.alert({ title: '提示', message: '申请成功！' }).then(() => {
                        this.refresh();
                    });
                } else {
                    Dialog.alert({ title: '提示', message: res.data.message });
                }
            })
        },

        //提示语判断
        judgeTips() {
            let fd = new FormData();
            fd.append("iccid", this.$route.query.oldIccid ? this.$route.query.oldIccid : localStorage.getItem('iccid'));
            wxRequest("applyChangeSim/isChange", fd, "post").then(res => {
                if (res.data.code == '200') {
                    let cardTypeStr = '电信';
                    if (res.data.data) {
                        cardTypeStr = res.data.data.cardType == 0 ? '移动' : res.data.data.cardType == 1 ? '电信' : '联通';
                    }

                    let lack = cardTypeStr == '移动' ? '电信' : '移动';
                    //  this.tips = '温馨提醒：'+cardTypeStr+'卡充足，'+lack+'卡缺货（发货时间可能较长）。新卡流量套餐为月底清零套餐。';
                }
            })
        },


        //判断是否需要支付邮费
        judgeIsNeedPostage() {
            let fd = new FormData();

            fd.append("iccid", this.$route.query.oldIccid ? this.$route.query.oldIccid : localStorage.getItem('iccid'));
            wxRequest("applyChangeSim/isNeedPostage", fd, "post").then(res => {
                this.isNeedPostage = res.data.code == 200;
            })
        },

        payPostage() {
            if (this.userInfo.takeNickname == '' || this.userInfo.takePhone == '' || this.userInfo.takeAddress == '' || this.userInfo.pcaAddress == '') {
                Dialog.alert({ title: '提示', message: '请确保信息完整正确' });
                return;
            }

            var data = JSON.parse(JSON.stringify(this.userInfo));
            wxRequest("applyChangeSim/add", data, "post").then(res => {
                if (res.data.code == 200) {
                    let _this = this;
                    let fd = new FormData();
                    fd.append("iccid", this.userInfo.oldIccid);
                    wxRequest("order/postage/add", fd, "post").then(res => {

                        wxRequest(
                            "sim/get/pay/state",
                            {
                                iccid: localStorage.getItem("iccid"),
                            },
                            "post"
                        ).then((res) => {
                            if (res.data.code == 200) {
                                window.location.href = res.data.data.jspay_url;

                            } else if (res.data.code == 561) {
                                window.location.href = res.data.data;
                            } else {
                                let param = res.data.data.param;
                                WeixinJSBridge.invoke(
                                    'getBrandWCPayRequest', param,
                                    function (res) {
                                        if (res.err_msg == "get_brand_wcpay_request:ok") {
                                            _this.judgeIsNeedPostage();
                                        }
                                    }
                                );
                            }
                        })

                    })
                } else {
                    Dialog.alert({ title: '提示', message: res.data.message });
                }
            })


        },

        showPopupVisible() {
            if (this.disabledFlag) {
                return;
            }
            this.popupVisible = true;
        },

        selectValue(value, index) {
            this.userInfo.changeCmccSimName = value
            if (value == '电信卡') {
                this.userInfo.changeCmccSim = 1;
            } else if (value == '联通卡') {
                this.userInfo.changeCmccSim = 3;
            } else if (value == '移动卡') {
                this.userInfo.changeCmccSim = 2;
            } else {
                this.userInfo.changeCmccSim = 6;
            }
            //  this.userInfo.changeCmccSim = value == '电信卡' ? 1 : value == '移动卡' ? 2 : 6;
            this.popupVisible = false;
        },

        showAddressVisible() {
            if (this.disabledFlag) {
                return;
            }
            this.addressVisible = true;
        },

        cancelSelectAddress() {
            this.addressTmp = '';
            this.userInfo.pcaAddress = '';
            this.addressVisible = false;
        },

        selectAddress(values) {
            if (!values[0].code || values[0].code.length < 1) {
                Toast.fail('请选择地区');
                return;
            }

            if (!values[1].code || values[1].code.length < 1) {
                Toast.fail('请选择地区');
                return;
            }

            if (!values[2].code || values[2].code.length < 1) {
                Toast.fail('请选择地区');
                return;
            }

            if (values[0].code == '110000' || values[0].code == '120000' ||
                values[0].code == '310000' || values[0].code == '500000') {
                this.addressTmp = values[0].name + values[2].name
            } else {
                this.addressTmp = values[0].name + values[1].name + values[2].name
            }

            this.userInfo.pcaAddress = this.addressTmp;
            this.addressVisible = false;
        },

        refresh() {
            var query = this.$route.query;
            if (query.disposeState) {
                this.userInfo = query;
                if (this.userInfo.disposeState == 1 || this.userInfo.disposeState == 3) {
                    this.disabledFlag = true;
                    return;
                }
            } else {
                var data = {
                    oldIccid: query.oldIccid
                }
                wxRequest("applyChangeSim/info", data, "post").then(res => {
                    if (res.data.code == 200) {
                        if (res.data.data.oldIccid != null) {
                            for (var key in this.userInfo) {
                                this.userInfo[key] = res.data.data[key];
                            }
                            this.userInfo.changeCmccSim = query.changeCmccSim;
                            switch (this.userInfo.disposeState) {
                                case 1:   //待审核
                                case 3:   //通过
                                    this.disabledFlag = true;
                                    break;
                                case 5:
                                    Dialog.alert({ title: '提示', message: '您没有权限申请换卡！' }).then(() => {
                                        this.$router.push({
                                            path: '/user/home',
                                            query: {
                                                'iccid': this.$store.state.iccid,
                                            }
                                        })
                                    });

                                    break;
                                default:
                                    break;
                            }
                        }
                        //换卡申请详情不存在
                        else {
                            this.userInfo.oldIccid = data.oldIccid;
                            this.defaultIndex = query.changeCmccSim;
                        }

                    }
                    else {
                        Dialog.alert({ title: '提示', message: res.data.message }).then(() => {
                            this.$router.push({
                                path: '/user/home',
                                query: {
                                    'iccid': this.$store.state.iccid,
                                }
                            })
                        });
                    }
                })
            }
        },


        toBackPostagePage() {
            this.$router.push({
                path: '/user/returnPostage',
                query: {
                    'oldIccid': this.recordLoginText
                }
            })
        }


    },
    created() {
        this.refresh();
        this.judgeIsNeedPostage();
        //提示语判断
        this.judgeTips();

    }
}
</script>
<style lang="less" scoped>
#userChgCard {
    em {
        display: block;
        background: #26a2ff;
        color: #fff;
        padding: 10px;
        line-height: 1.5em;
    }

    .btnOuter {
        margin: 20px 0 40px;
        padding: 0 5%;
    }


    .form-input {
        .tip {
            padding: 2px 10px;
        }
    }

    .tip {
        color: red;
        line-height: 16px;
        font-size: 12px;
    }
}
</style>

<style>
#userChgCard .form-input .van-field__control {
    line-height: 24px;
}
</style>